var siteConfig  = {
    "cloudRoot": "https://storage.googleapis.com/assets.mcomnyapps.net/welcome-to-macys/",
    "cloudVersion": "2026-04",
    "siteName": "welcome-to-macys",
    "assets_dir": "https://storage.googleapis.com/assets.mcomnyapps.net/welcome-to-macys/2026-04"
}